export enum AuthorizationFieldType {
    Organization = 'Organization',
    Person = 'Person',
}
